import { apiService } from './api.service';
import { CR_API_ENDPOINTS } from '../constants';
import { Rsd } from '../types';

class RsdsService {
  /**
   * Get all RSDs, optionally filtered by inverter brand.
   * @param inverterBrandId - Optional UUID to filter by inverter brand
   * @returns Array of RSDs
   */
  async getAll(inverterBrandId?: string): Promise<Rsd[]> {
    const params = inverterBrandId ? { inverterBrandId } : undefined;
    return apiService.get<Rsd[]>(CR_API_ENDPOINTS.RSDS, params);
  }

  /**
   * Create a new RSD linked to an inverter brand.
   * @param data - RSD name and inverter brand ID
   * @returns The created RSD
   */
  async create(data: { name: string; inverter_brand_id: string }): Promise<Rsd> {
    return apiService.post<Rsd>(CR_API_ENDPOINTS.RSDS, data);
  }

  /**
   * Delete an RSD by ID.
   * @param id - UUID of the RSD to delete
   */
  async delete(id: string): Promise<void> {
    return apiService.delete<void>(`${CR_API_ENDPOINTS.RSDS}/${id}`);
  }
}

export const rsdsService = new RsdsService();
